export const SLIDE_ALL = 'todos';
export const SLIDE_VET = 'veterinarias';
export const SLIDE_FOOD = 'comida mascotas';
export const SLIDE_ACCESSORY = 'accesorios';
export const SLIDE_HOSPITAL = 'hospital';
export const SLIDE_GROOMING = 'grooming';
export const SLIDE_HOSPITAL247 = 'hospital 24/7';
export const SLIDE_VET247 = 'veterinaria 24/7';